import SpeedTest from '@te/cdev-web-sdk';
import getResult from './get-result';

import i18n from './i18n';

if (i18n.rtl) {
  document.body.dir = 'rtl';
}

const isIE = navigator.userAgent.includes('Trident');
if (isIE) {
  document.body.classList.add('is-ie');
}

const startBtnEl = document.querySelector('.test-animated-el .js-start');
const errorMssgEl = document.querySelector('.test-animated-el .js-error');

let resultEls;
const initResultEls = () => {
  resultEls = {
    latency: {
      val: document.querySelector('.test-animated-el .result-latency-val'),
      unit: document.querySelector('.test-animated-el .result-latency-unit'),
      parent: document.querySelector('.test-animated-el .box__main-latency'),
    },
    jitter: {
      val: document.querySelector('.test-animated-el .result-jitter-val'),
      unit: document.querySelector('.test-animated-el .result-jitter-unit'),
      parent: document.querySelector('.test-animated-el .box__main-jitter'),
    },
    download: {
      val: document.querySelector('.test-animated-el .result-download-val'),
      unit: document.querySelector('.test-animated-el .result-download-unit'),
      parent: document.querySelector('.test-animated-el .box__main-download'),
    },
    upload: {
      val: document.querySelector('.test-animated-el .result-upload-val'),
      unit: document.querySelector('.test-animated-el .result-upload-unit'),
      parent: document.querySelector('.test-animated-el .box__main-upload'),
    },
  };
};

initResultEls();

const animationEls = {
  latency: document.querySelector('#animate-latency'),
  download: document.querySelector('#animate-download'),
  upload: {
    line: document.querySelector('#animate-upload-line'),
    arrow: document.querySelector('#animate-upload-arrow'),
  },
};

export default function setupTest(options) {
  startBtnEl.addEventListener('click', () => {
    if (startBtnEl.classList.contains('start__btn--disabled')) {
      return;
    }

    errorMssgEl.textContent = '';
    errorMssgEl.classList.add('u-hidden');
    startBtnEl.classList.add('start__btn--disabled');

    window.parent.postMessage({ type: 'reset' }, '*');

    Object.keys(resultEls).forEach((resultEl) => {
      resultEls[resultEl].parent.classList.remove('display-result');
    });

    // className.add doesn't work in IE11 on SVG elements
    animationEls.latency.className.baseVal = 'animate-latency';
    resultEls.latency.parent.classList.add('animating');

    if (window.ga) {
      window.ga('send', 'test-start');
    }

    const st = new SpeedTest(options);

    st.on('test-done', (test, results) => {
      const { unit, val } = getResult(results);

      if (test === 'latency') {
        animationEls.latency.className.baseVal = '';
        animationEls.download.className.baseVal = 'animate-download';
        resultEls.latency.parent.classList.remove('animating');
        resultEls.download.parent.classList.add('animating');

        // This hack is to stop it for flashing forever
        if (isIE) {
          setTimeout(() => {
            resultEls.latency.parent.outerHTML =
              resultEls.latency.parent.outerHTML;
            initResultEls();
          }, 5);
        }

        const jitterRes = getResult(results, 'jitter');

        // delay to allow for aria-live to read results
        // without this the jitter results are ignored
        if (jitterRes) {
          setTimeout(() => {
            resultEls.jitter.val.innerHTML =
              jitterRes.val >= 10
                ? Math.round(jitterRes.val)
                : Math.round(jitterRes.val * 10) / 10;
            resultEls.jitter.unit.innerHTML = i18n[jitterRes.unit];
            resultEls.jitter.parent.classList.add('display-result');
          }, 450);
        }
      } else if (test === 'download') {
        animationEls.download.className.baseVal = '';
        animationEls.upload.line.className.baseVal = 'animate-upload-line';
        animationEls.upload.arrow.className.baseVal = 'animate-upload-arrow';
        resultEls.download.parent.classList.remove('animating');
        resultEls.upload.parent.classList.add('animating');

        if (isIE) {
          setTimeout(() => {
            resultEls.download.parent.outerHTML =
              resultEls.download.parent.outerHTML;
            initResultEls();
          }, 5);
        }
      } else if (test === 'upload') {
        animationEls.upload.line.className.baseVal = '';
        animationEls.upload.arrow.className.baseVal = '';
        resultEls.upload.parent.classList.remove('animating');

        if (isIE) {
          setTimeout(() => {
            resultEls.upload.parent.outerHTML =
              resultEls.upload.parent.outerHTML;
            initResultEls();
          }, 5);
        }
      }

      resultEls[test].val.innerHTML =
        val >= 10 ? Math.round(val) : Math.round(val * 10) / 10;
      resultEls[test].unit.innerHTML = i18n[unit];
      resultEls[test].parent.classList.add('display-result');
    });

    st.on('done', () => {
      startBtnEl.classList.remove('start__btn--disabled');

      if (window.ga) {
        window.ga('send', 'test-end');
      }
    });

    st.on('warning', (code) => {
      window.parent.postMessage({ type: 'warning', code }, '*');
    });

    st.on('test-id', (testId) => {
      window.parent.postMessage({ type: 'test-id', data: testId }, '*');
    });

    st.on('error', (error) => {
      const errorType = (error && error.type) || null;
      const errorCode = 'TEST_FAILED';

      if (errorType && errorType === 'INITIATE_ERROR') {
        const errorMssg = error.message;
        window.parent.postMessage(
          { type: 'warning', code: errorCode, error: errorMssg.toString() },
          '*',
        );

        // Let user know there has been a problem
        errorMssgEl.textContent = i18n.initiateFail;
        errorMssgEl.classList.remove('u-hidden');
        startBtnEl.classList.remove('start__btn--disabled');
        animationEls.latency.className.baseVal = '';
        resultEls.latency.parent.classList.remove('animating');
        return;
      }

      const code = typeof error === 'string' ? error : errorCode;
      window.parent.postMessage(
        { type: 'warning', code, error: error.toString() },
        '*',
      );
    });

    st.runSpeedTest();
  });
}



// WEBPACK FOOTER //
// ./src/js/lib/setup-animated-test.js